<template>
  <div :class="[ns.e('item'), ns.e(variant)]">
    <picture-filled v-if="variant === 'image'" />
  </div>
</template>

<script lang="ts" setup>
import { useNamespace } from '@lit-element/hooks'
import { PictureFilled } from '@inte-cloud/icons-vue'
import { skeletonItemProps } from './skeleton-item'

defineOptions({
  name: 'LtSkeletonItem',
})
defineProps(skeletonItemProps)
const ns = useNamespace('skeleton')
</script>
